import { create } from "../../../common/utils/zustand_state_manager";
import { usecontroleEstoqueRepositories } from "./use_repositories"; // {{ LAST DECL IMPORT }};
import { IGetAllEstoqueUseCase } from "../../../features/controleEstoque/presentation/useCases/read/get_all_estoque_use_case";
import { GetAllEstoqueUseCase } from "../../../features/controleEstoque/domain/useCases/read/get_all_entrada_produtos_use_case";
import { ICreateEntradaPUseCase } from "../../../features/controleEstoque/presentation/useCases/create/create_entrada_produtos_use_case";
import { IUpdateEntradaPUseCase } from "../../../features/controleEstoque/presentation/useCases/update/update_entrada_produtos_use_case";
import { IDeleteEntradaPUseCase } from "../../../features/controleEstoque/presentation/useCases/delete/delete_entrada_produtos_use_case";
import { CreateEntradaPUseCase } from "../../../features/controleEstoque/domain/useCases/create/create_entrada_produtos_use_case";
import { UpdateEntradaPUseCase } from "../../../features/controleEstoque/domain/useCases/update/update_entrada_produtos_use_case";
import { DeleteEntradaPUseCase } from "../../../features/controleEstoque/domain/useCases/delete/delete_entrada_produto_use_case";
import { ICreateEntradaMultiPUseCase } from "../../../features/controleEstoque/presentation/useCases/create/create_entrada_produtos_multi_use_case";
import { CreateEntradaMultiPUseCase } from "../../../features/controleEstoque/domain/useCases/create/create_entrada_produtos_multi_use_case";
import { IUpdateEntradaMultiPUseCase } from "../../../features/controleEstoque/presentation/useCases/update/update_entrada_produtos_multi_use_case";
import { UpdateEntradaMultiPUseCase } from "../../../features/controleEstoque/domain/useCases/update/update_entrada_produtos_multi_use_case";
import { IGetAllEstoqueSaidaUseCase } from "../../../features/controleEstoque/presentation/useCases/read/get_all_sainda_use_case";
import { GetAllSaidaProdutosUseCase } from "../../../features/controleEstoque/domain/useCases/read/get_all_saida_produtos_use_case";
import { ICreateSaidaPUseCase } from "../../../features/controleEstoque/presentation/useCases/create/create_saida_produtos_use_case";
import { IUpdateSaidaPUseCase } from "../../../features/controleEstoque/presentation/useCases/update/update_saida_produtos_use_case";
import { IDeleteSaidaPUseCase } from "../../../features/controleEstoque/presentation/useCases/delete/delete_saida_produtos_use_case";
import { CreateSaidaPUseCase } from "../../../features/controleEstoque/domain/useCases/create/create_saida_produtos_use_case";
import { UpdateSaidaPUseCase } from "../../../features/controleEstoque/domain/useCases/update/update_saida_produtos_use_case";
import { DeleteSaidaPUseCase } from "../../../features/controleEstoque/domain/useCases/delete/delete_saida_produto_use_case";
import { ICreateSaidaMultiPUseCase } from "../../../features/controleEstoque/presentation/useCases/create/create_saida_produtos_multi_use_case";
import { IUpdateSaidaMultiPUseCase } from "../../../features/controleEstoque/presentation/useCases/update/update_saida_produtos_multi_use_case ";
import { CreateSaidaMultiPUseCase } from "../../../features/controleEstoque/domain/useCases/create/create_saida_produtos_multi_use_case";
import { UpdateSaidaMultiPUseCase } from "../../../features/controleEstoque/domain/useCases/update/update_saida_multi_produtos_use_case";
import { IGetAllEstoqueControleUseCase } from "../../../features/controleEstoque/presentation/useCases/read/get_all_controle_estoque_use_case";
import { IDeleteControleEstoqueUseCase } from "../../../features/controleEstoque/presentation/useCases/delete/delete_controle_estoque_use_case";
import { GetAllControleEstoqueUseCase } from "../../../features/controleEstoque/domain/useCases/read/get_all_controle_estoque_use_case";
import { DeleteControleEstoqueUseCase } from "../../../features/controleEstoque/domain/useCases/delete/delete_controle_estoque_use_case";
import { ICreateControleUseCase } from "../../../features/controleEstoque/presentation/useCases/create/create_controle_use_case";
import { IUpdateControleUseCase } from "../../../features/controleEstoque/presentation/useCases/update/update_controle_use_case";
import { UpdateControleUseCase } from "../../../features/controleEstoque/domain/useCases/update/update_controle_produtos_use_case";
import { CreateControleUseCase } from "../../../features/controleEstoque/domain/useCases/create/create_controle_produtos_use_case";
import { IGetAllItemControleUseCase } from "../../../features/controleEstoque/presentation/useCases/read/get_all_item_controle_estoque_use_case";
import { GetAllItemControleUseCase } from "../../../features/controleEstoque/domain/useCases/read/get_all_item_controle_estoque_use_case";
import { ICreateItemControleUseCase } from "../../../features/controleEstoque/presentation/useCases/create/create_item_controle_use_case";
import { CreateItemControleUseCase } from "../../../features/controleEstoque/domain/useCases/create/create_item_controle_use_case";
import { IUpdateItemControleUseCase } from "../../../features/controleEstoque/presentation/useCases/update/update_item_controle_multi_use_case";
import { UpdateItemControleUseCase } from "../../../features/controleEstoque/domain/useCases/update/update_item_controle_multi_use_case";
import { IDeleteItemControleUseCase } from "../../../features/controleEstoque/presentation/useCases/delete/delete_item_controle_use_case";
import { DeleteItemControleUseCase } from "../../../features/controleEstoque/domain/useCases/delete/delete_item_controle_use_case";

export type ControleEstoqueState = {
  //#region Entrada Produtos
  getAllListagemEstoqueUseCase: IGetAllEstoqueUseCase,
  createEntradaPUseCase: ICreateEntradaPUseCase,
  createEntradaMultiPUseCase: ICreateEntradaMultiPUseCase,
  updateEntradaPUseCase: IUpdateEntradaPUseCase,
  updateEntradaMultiPUseCase: IUpdateEntradaMultiPUseCase,
  deleteEntradaPUseCase: IDeleteEntradaPUseCase,
  //#endregion

  //#region Saida Produtos
  getAllListagemSaidaUseCase: IGetAllEstoqueSaidaUseCase,
  createSaidaPUseCase: ICreateSaidaPUseCase,
  createSaidaMultiPUseCase: ICreateSaidaMultiPUseCase,
  updateSaidaPUseCase: IUpdateSaidaPUseCase,
  updateSaidaMultiPUseCase: IUpdateSaidaMultiPUseCase,
  deleteSaidaPUseCase: IDeleteSaidaPUseCase,
  //#endregion

  //#region Controle Produtos
  getAllListagemControleUseCase: IGetAllEstoqueControleUseCase,
  deleteControleEstoqueUseCase: IDeleteControleEstoqueUseCase,
  createControleUseCase: ICreateControleUseCase,
  updateControleUseCase: IUpdateControleUseCase,
  //#endregion

  //#region Item Controle Estoque
  getAllListagemItemControleUseCase: IGetAllItemControleUseCase,
  deleteItemControleUseCase: IDeleteItemControleUseCase,
  createItemControleUseCase: ICreateItemControleUseCase,
  updateItemControleUseCase: IUpdateItemControleUseCase,
  //#endregion
  // {{ LAST DECL INTERFACE }}
};

export const useControleEstoqueUseCases = create<ControleEstoqueState>((set, get) => {
  const { controleEstoqueRepository: repository } = usecontroleEstoqueRepositories.getState()
  return ({
    //#region Entrada Produtos 
    getAllListagemEstoqueUseCase: new GetAllEstoqueUseCase(repository),
    createEntradaPUseCase: new CreateEntradaPUseCase(repository),
    createEntradaMultiPUseCase: new CreateEntradaMultiPUseCase(repository),
    updateEntradaPUseCase: new UpdateEntradaPUseCase(repository),
    updateEntradaMultiPUseCase: new UpdateEntradaMultiPUseCase(repository),
    deleteEntradaPUseCase: new DeleteEntradaPUseCase(repository),
    //#endregion
    //#region Saida Produtos 
    getAllListagemSaidaUseCase: new GetAllSaidaProdutosUseCase(repository),
    createSaidaPUseCase: new CreateSaidaPUseCase(repository),
    createSaidaMultiPUseCase: new CreateSaidaMultiPUseCase(repository),
    updateSaidaMultiPUseCase: new UpdateSaidaMultiPUseCase(repository),
    updateSaidaPUseCase: new UpdateSaidaPUseCase(repository),
    deleteSaidaPUseCase: new DeleteSaidaPUseCase(repository),
    //#endregion

    //#region Controle Produtos 
    getAllListagemControleUseCase: new GetAllControleEstoqueUseCase(repository),
    deleteControleEstoqueUseCase: new DeleteControleEstoqueUseCase(repository),
    createControleUseCase: new CreateControleUseCase(repository),
    updateControleUseCase: new UpdateControleUseCase(repository), // {{ LAST DECL IMPLEMENTATION }}
    //#endregion

    //#region Item Controle Estoque 
    getAllListagemItemControleUseCase: new GetAllItemControleUseCase(repository),
    createItemControleUseCase: new CreateItemControleUseCase(repository),
    updateItemControleUseCase: new UpdateItemControleUseCase(repository),
    deleteItemControleUseCase: new DeleteItemControleUseCase(repository),
    //#endregion

  });
});